import { Database, Link2, UploadCloud } from "lucide-react";
import { NavLink } from "@/components/NavLink";


const SECTIONS = [
  { to: "/datacore/data-uploads", label: "Data uploads", icon: UploadCloud },
  { to: "/datacore/xero", label: "Xero", icon: Link2 },
  { to: "/datacore/cch", label: "CCH", icon: Database },
];

const DatacoreSubNav = () => (
  <nav
    aria-label="Datacore sections"
    className="mb-5 flex flex-wrap items-center gap-1 border-b border-border pb-3"
  >
    {SECTIONS.map(({ to, label, icon: Icon }) => (
      <NavLink
        key={to}
        to={to}
        className="flex items-center gap-2 rounded-md px-3 py-1.5 text-sm text-muted-foreground transition-colors hover:bg-accent hover:text-accent-foreground"
        activeClassName="bg-primary text-primary-foreground font-medium hover:bg-primary hover:text-primary-foreground"
      >
        <Icon className="h-4 w-4" />
        {label}
      </NavLink>
    ))}
  </nav>
);

export default DatacoreSubNav;
